import type { TimelineItem } from "@/mocks/types";

interface TimelineProps {
  items: TimelineItem[];
}

export default function Timeline({ items }: TimelineProps) {
  return (
    <ol className="relative space-y-6 border-l border-background-300 pl-6">
      {items.map((item, index) => {
        const isLatest = index === items.length - 1;
        return (
          <li key={`${item.time}-${index}`} className="relative">
            <span
              className={`absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 ${
                isLatest
                  ? "border-primary-500 bg-primary-500"
                  : "border-background-300 bg-background-50"
              }`}
              aria-hidden="true"
            >
              {isLatest && <span className="h-1.5 w-1.5 rounded-full bg-background-50"></span>}
            </span>
            <time className="font-label text-[12px] font-medium text-primary-600">{item.time}</time>
            <p className="mt-1 text-sm leading-relaxed text-foreground-700">{item.text}</p>
          </li>
        );
      })}
    </ol>
  );
}